import { Component, OnInit } from '@angular/core';

import { Divisao } from "../shared/divisao.model";
import { divisoesModuleName } from "../shared/data.service";
import { DivisaoApiService } from "../shared/divisao-api.service";
import { DivisaoNavigationService } from "../shared/divisao-navigation.service";
import { DivisoesService } from "../shared/divisao.service";
import { UtilService } from "../../../shared/services/util.service";

@Component({
  template: require('./divisao-list.component.html'),
  styles: [require('./divisao-list.component.css')]
})
export class DivisaoListComponent implements OnInit {
  list: Divisao[] = [];
  loading: boolean = true;
  showDisabled: boolean = false;
  divisoesModuleName: any = divisoesModuleName;

  constructor(
    private _divisoesApiService: DivisaoApiService,
    private _divisoesService: DivisoesService,
    private _divisaoNavigationService: DivisaoNavigationService,
    private _utilService: UtilService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._divisoesService.clearSessionStorage();
    this._divisaoNavigationService.goToNew();
  }

  clickEdit(item: Divisao) {
    this._divisoesService.clearSessionStorage();
    this._divisaoNavigationService.goToEdit(item.id);
  }

  clickDelete(item: Divisao) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private getAll() {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.list = Response;
      }
      this.loading = false;
    }.bind(this));

    this._divisoesApiService.onGetAll(onDone);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._divisoesApiService.onDelete(item.id, onDone);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/divisoes/divisao-list/divisao-list.component.ts
 **/